import { redirect } from "react-router-dom"

export function printLoaderRedirect() {

    return redirect('/')
}